<template>
  <div class="" :data-background-color="color">
    <div class="card-content text-center">
      <div class="chart-circle flexer" :data-percent="percentage" ref="chart">
        <div class="text-poraba">
          <p v-if="porabljenaKolicina !== null">
            {{porabljenaKolicina}} {{porabljenoEnote}}
          </p>
          <p v-else>
            ...
          </p>
        </div>
        <span class="text-skupina-kol">
          _______
        </span>
        <div class="text-kolicina">
          <p v-if="skupnaKolicina !== null">
            {{skupnaKolicina + ' ' + skupnaKolicinaEnote}}
          </p>
          <p v-else>
            ...
          </p>
        </div>
      </div>
    </div>
    <div class="text-title">
      <h5 style="">
        {{title}}
      </h5>
      <p class="description">
        {{description}}
      </p>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'circle-chart-card',
    props: {
      color: {
        type: String,
        default: 'blue'
      },
      porabljenaKolicina: {
        type: Number,
        default: 0
      },
      skupnaKolicina: {
        type: Number,
        default: 0
      },
      percentage: {
        type: Number,
        default: 0
      },
      porabljenoEnote: String,
      skupnaKolicinaEnote: String,
      title: String,
      description: String,
      size1: {
        type: Number,
        default: 0
      },
      sirinaKroga: {
        type: Number,
        default: 0
      }
    },
    data () {
      return {
        chartId: 'no-id',
        chart: null
      }
    },
    methods: {
      updateChartId () {
        var currentTime = new Date().getTime().toString()
        var randomInt = this.getRandomInt(0, currentTime)
        this.chartId = `div_${randomInt}`
      },
      getRandomInt (min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min
      },
      renderChart (EasyPieChart, osivelGraf) {
        if (osivelGraf) {
          /* eslint-disable no-new */
          this.chart = new EasyPieChart(this.$refs.chart, {
            lineWidth: this.sirinaKroga,
            size: this.size1,
            scaleColor: false,
            trackColor: '#C6C6C6',
            barColor: '#EF7D00',
            animate: ({duration: 1000, enabled: true}),
            lineCap: 'square'
          })
        } else {
          /* eslint-disable no-new */
          this.chart = new EasyPieChart(this.$refs.chart, {
            lineWidth: this.sirinaKroga,
            size: this.size1,
            scaleColor: false,
            trackColor: '#C6C6C6',
            barColor: '#EF7D00',
            animate: ({duration: 1000, enabled: true}),
            lineCap: 'square'
          })
        }
      }
    },
    async mounted () {
      this.updateChartId()
      let EasyPieChart = await import('easy-pie-chart')
      if (this.percentage === 0) {
        this.renderChart(EasyPieChart, true)
      } else {
        this.renderChart(EasyPieChart, false)
      }
    },
    watch: {
      percentage: function (newVal) {
        if (this.chart) {
          this.chart.update(newVal)
        }
      }
    }
  }
</script>
<style scoped>
  .flexer {
    display:flex;
    flex-direction:column;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    -ms-flex: 1;
  }

  .text-poraba {
    display:block;
    height: 50px;
    font-size:0.5em;
    margin-top:16px;
    margin-right:0px;
    color:#080809;
  }

  .text-skupina-kol{
    height:16px;
    position:absolute;
    bottom:83px;
    left:18px;
    font-size:20px;
    color:#080809;
  }

  .text-kolicina {
    display:block;
    height: 150px;
    margin-top:-4px;
    margin-right:0px;
    font-size:0.5em;
  }
  .text-title {
    margin-top:5px;
    font-size:10px;
    height:60px;
    overflow:hidden;
    text-align:center;
    color: #080809;
  }

  @media screen and (min-width:573px) {
    .text-title {
      font-size:11px;
    }
  }

  @media screen and (max-width:573px) {
    .text-title > h5 {
      font-size:13px;
    }
  }

  @media screen and (min-width:2149px) {
    .text-title {
      font-size:14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Cards/CircleChartCard.vue